import posthog from "posthog-js";
import { isMyAppWKWebView } from "./isMyAppWKWebView";
import { PushPreferences } from "@/components/Modals/NotificationModal";

export async function requestNotificationAuthorization(preference: PushPreferences): Promise<boolean> {
    if (isMyAppWKWebView()) {
        try {
            // biome-ignore lint/suspicious/noExplicitAny: <explanation>
            const status = await (window.webkit as any).messageHandlers.requestNotificationAuthorization.postMessage(undefined);
            posthog.capture("request_notification_authorization", {
                status,
            });

            if (status === "granted") {
                // Then subscribe to the topic
                // biome-ignore lint/suspicious/noExplicitAny: <explanation>
                await (window.webkit as any).messageHandlers.subscribeToNotifications.postMessage(preference, (_: any, error: any) => {
                  posthog.capture("subscribedToNotifications", {
                    success: !error,
                    topic: "daily_promos",
                    error: error ? error : undefined
                  });
                });
                
                return true;
            }
            
            return false;
        } catch {
            posthog.capture("bridge_error", {
                function: "requestNotificationAuthorization"
            });
            // no-op
            return false;
        }
    }

    return false;
}